import {MiddlewareContext} from '@/lib/middleware'
import {App} from '@/project'
import {RootState} from '@/store'

/**
 * 초대 링크의 유효성 검사
 * @param ctx
 */
export function beforeEnter(ctx: MiddlewareContext<App, RootState>) {
  const {store, to: {params: {invitationId = ''}, name}} = ctx

  if(!store) {
    throw new Error('[middleware invitation] need store')
  }

  if(!invitationId) {
    return ctx.next({name: 'wrong-access'})
  }

  const startInvitationRouteName = 'invitation'
  const {invitationId: stateInvitationId} = store.state.invitation
  const {accessToken} = store.state.auth

  if(name !== startInvitationRouteName && (!stateInvitationId || !accessToken)) {
    return ctx.next({name: startInvitationRouteName, params: {invitationId}})
  }

  const {bizs} = store.state.biz
  const {bizId = ''} = store.state.invitation
  const isAlreadySignUpBiz = Boolean(bizs.find((biz) => biz.id === bizId))

  if(isAlreadySignUpBiz) {
    return ctx.next({name: 'home', params: {bizId: String(bizId)}})
  }

  store.dispatch('invitation/getInvitation', {invitationId})
    .then(() => {
      return ctx.next()
    })
    .catch((err) => {
      const {response: {status = -1} = {}} = err || {}
      if(status === 410) {
        ctx.next({name: 'expired-invitation'})
      } else {
        ctx.next({name: 'wrong-access'})
      }
    })
}
